/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { FC } from 'react';
import { Linkable } from '@/components/blocks/Linkable';
import { Stack, Typography } from '@mui/material';
import { useLocalization } from '@/data/Localization';
import { UserLogon } from '@/data/Content/Login';
import {
	createAccountButtonSX,
	createAccountLabelSX,
} from '@/components/content/Login/styles/button';
import { useForm } from '@/utils/useForm';
import { useNextRouter } from '@/data/Content/_NextRouter';

const initLoginValues: UserLogon = {
	email: '',
	logonPassword: '',
	rememberMe: false,
};
type Props = {
	onSubmit: (value: UserLogon) => void;
};

export const CreateAccountLoginForm: FC<Props> = ({ onSubmit }) => {
	const RouteLocal = useLocalization('Routes');
	const signInNLS = useLocalization('SignIn');
	const router = useNextRouter();

	const { handleSubmit, formRef } = useForm(initLoginValues);

	const noAccountMsg = signInNLS.noAccount.t();

	return (
		<Stack spacing={2} component="form" onSubmit={handleSubmit(onSubmit)} noValidate ref={formRef}>
			<Stack>
				<Stack alignItems="center" spacing={'13px'}>
					<Typography sx={createAccountLabelSX}>{noAccountMsg}</Typography>
					<Linkable
						href={{
							pathname: RouteLocal.Registration.route.t(),
							query: router.query.flow ? { flow: router.query.flow } : {},
						}}
						type="button"
						variant="contained"
						sx={createAccountButtonSX}
					>
						{'Crear una cuenta'}
					</Linkable>
				</Stack>
			</Stack>
		</Stack>
	);
};
